import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import PanelLayout from '../components/panel/PanelLayout';
import PanelDashboard from '../components/panel/PanelDashboard';
import WebIDsList from '../components/panel/WebIDsList';
import WebIDDetail from '../components/panel/WebIDDetail';

/**
 * @component PanelPage
 * @description Página principal del panel de usuario con layout y rutas
 * Rutas: /panel, /panel/webids, /panel/webids/:id
 */

const PanelPage: React.FC = () => {
  return (
    <PanelLayout>
      <Routes>
        {/* Dashboard principal del panel */}
        <Route index element={<PanelDashboard />} />
        
        {/* Lista de WebIDs del usuario */}
        <Route path="webids" element={<WebIDsList />} />
        
        {/* Detalle de un WebID específico */}
        <Route path="webids/:id" element={<WebIDDetail />} />
        
        {/* Redirección por defecto */}
        <Route path="*" element={<Navigate to="/panel" replace />} />
      </Routes>
    </PanelLayout>
  );
};

export default PanelPage;
